module.exports = __webpack_public_path__ + "static/bg-yellow-50e380517c43beb7468701bd0af28c57.jpg";